import ConnectionSupport from 'sharedreact/utils/ConnectionSupport';
import ErrorData from 'sharedreact/data/ErrorData';

type OnSuccess = () => void;
type OnError = (error: ErrorData) => void;

function updateServerLog (logEntries: any, onSuccess: OnSuccess, onError: OnError) {
  ConnectionSupport.post(
    'saveInLogFile',
    {items: logEntries},
    onSuccess,
    onError
  );
}

const LoggingConnection = {
  updateServerLog
};

export default LoggingConnection;